module.exports = __webpack_public_path__ + "static/media/Guggenheim.2886ea51.webp";